import * as logger from "common/logger";
import * as config from "config";
import { call, put, select, takeLatest } from "redux-saga/effects";
import * as types from "store/actions/input/exposure/hazardActionTypes";
import * as actions from "store/actions/input/exposure/hazardActions";
import * as exposureSelectors from "store/selectors/input/exposure/exposureSelectors";
import * as utils from "utils";

export function* updateHazardProfileSummary() {
  try {
    const hazardProfileInput = yield select(
      exposureSelectors.selectHazardProfileInput
    );

    // Only call the endpoint if there are actually files uploaded
    if (!hazardProfileInput?.files || hazardProfileInput.files.length === 0) {
      return;
    }

    yield put(actions.updateHazardProfileSummaryStarted());
    const result = yield call(
      utils.authenticatedFetch,
      config.endpoints.claims("summarize-hazard-profile"),
      {
        body: JSON.stringify(hazardProfileInput),
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const hazardProfileSummary = yield call([result, result.json]);
    yield put(
      actions.updateHazardProfileSummarySucceeded(hazardProfileSummary)
    );
  } catch (e) {
    logger.exception(e);
    yield put(actions.updateHazardProfileSummaryFailed());
  }
}

export default function* hazardProfileSaga() {
  yield takeLatest(
    types.UPDATE_HAZARD_PROFILE_SUMMARY,
    updateHazardProfileSummary
  );
}
